/*
 * Sacred Essence - two cart tweaks that Horizon does not give us out of the box.
 *
 * 1) REWARDS BAR IN THE DRAWER
 *    The cart page renders the bar server-side from blocks/_cart-title.liquid.
 *    Horizon's drawer (snippets/header-actions.liquid) does not use that block,
 *    so the drawer gets its bar from here instead. Same thresholds, same
 *    wording - keep the two in sync.
 *
 *    Progress is measured on original_total_price (the subtotal BEFORE cart
 *    discounts). total_price is net of the automatic 10% discount, so past $250
 *    it falls back under the threshold and the bar would ask for money the
 *    customer has already spent.
 *
 * 2) DISCOUNT CODE FIELD
 *    Horizon collapses it into a <details> labelled just "Discount", closed by
 *    default. Customers do not find it. We open it, relabel it and give it a
 *    tinted box so it reads as a field you can type in.
 */
(function () {
  var TIER_SHIP = 10000; // free shipping over $100, matches the Australia shipping zone
  var TIER_DISC = 25000; // 10% off over $250, matches the automatic discount
  var SHIP_MARK = 40; // where the first milestone sits on the track, in %

  var TRUCK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2"/><path d="M14 9h4l4 4v4a1 1 0 0 1-1 1h-1"/><circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg>';
  var CHECK =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 12 2 2 4-4"/><circle cx="12" cy="12" r="9"/></svg>';

  var CSS = [
    '.se-rw--drawer{--se-rw-purple:#4A2A7A;--se-rw-track:#E3D8F5;--se-rw-ink:#150C22;padding:0 var(--padding-lg,20px);margin:0 0 16px;text-align:left}',
    '.se-rw--drawer .se-rw-msg{display:flex;align-items:center;gap:9px;margin:0 0 11px;font-size:13px;line-height:1.4;color:var(--se-rw-ink)}',
    '.se-rw--drawer .se-rw-msg svg{width:18px;height:18px;flex:none;color:var(--se-rw-purple)}',
    '.se-rw--drawer .se-rw-msg b{font-weight:700;color:var(--se-rw-purple)}',
    '.se-rw--drawer.se-rw--complete .se-rw-msg svg{color:#1F8A5B}',
    '.se-rw--drawer .se-rw-track{position:relative;height:9px;border-radius:999px;background:var(--se-rw-track)}',
    '.se-rw--drawer .se-rw-fill{position:absolute;top:0;bottom:0;left:0;border-radius:999px;background:linear-gradient(90deg,#6A45A0,#4A2A7A 60%,#2E1A50);background-size:200% 100%;transition:width .55s cubic-bezier(.22,.8,.3,1);animation:se-rw-shimmer 2.4s linear infinite}',
    '@keyframes se-rw-shimmer{0%{background-position:0 0}100%{background-position:-200% 0}}',
    '@media (prefers-reduced-motion:reduce){.se-rw--drawer .se-rw-fill{animation:none;transition:none}}',
    '.se-rw--drawer .se-rw-dot{position:absolute;top:50%;width:15px;height:15px;margin-left:-7.5px;transform:translateY(-50%);border-radius:50%;background:#fff;border:2px solid var(--se-rw-track);transition:.3s}',
    '.se-rw--drawer .se-rw-dot--end{right:0;left:auto;margin-left:0}',
    '.se-rw--drawer .se-rw-dot.is-on{background:var(--se-rw-purple);border-color:var(--se-rw-purple);box-shadow:0 0 0 4px rgba(74,42,122,.16)}',
    '.se-rw--drawer .se-rw-legend{position:relative;height:30px;margin-top:9px;font-size:11px;line-height:1.25}',
    '.se-rw--drawer .se-rw-legend span{position:absolute;top:0;transform:translateX(-50%);text-align:center;color:#6D6483;font-weight:600;white-space:nowrap}',
    '.se-rw--drawer .se-rw-legend span i{display:block;font-style:normal;font-weight:700;font-size:11.5px;color:#9A90AE}',
    '.se-rw--drawer .se-rw-legend span.is-on,.se-rw--drawer .se-rw-legend span.is-on i{color:var(--se-rw-purple)}',
    '.se-rw--drawer .se-rw-legend .se-rw-legend--end{right:0;left:auto;transform:none;text-align:right}',
    /* --- discount code field --- */
    '.cart-discount[data-se-disc]{background:#F1EBFA;border:1px solid #D6C9EE;border-radius:12px;padding:12px 14px;margin-block:10px}',
    '.cart-discount[data-se-disc] .cart-discount__summary{list-style:none;cursor:default;pointer-events:none;margin-bottom:9px}',
    '.cart-discount[data-se-disc] .cart-discount__summary::-webkit-details-marker{display:none}',
    '.cart-discount[data-se-disc] .cart-totals__icon{display:none}',
    '.cart-discount[data-se-disc] .cart-discount__label{font-weight:700;font-size:13.5px;color:#4A2A7A}',
    '.cart-discount[data-se-disc] .cart-discount__form{display:flex;gap:8px}',
    '.cart-discount[data-se-disc] .cart-discount__input{flex:1;background:#fff;border:1px solid #B9A6DC;border-radius:8px;padding:10px 12px;font-size:14px}',
    '.cart-discount[data-se-disc] .cart-discount__input:focus{outline:2px solid #4A2A7A;outline-offset:-1px}'
  ].join('');

  function injectStyles() {
    if (document.getElementById('se-rw-styles')) return;
    var s = document.createElement('style');
    s.id = 'se-rw-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function markup(total) {
    var pct = Math.min(100, (total * 100) / TIER_DISC);
    var icon = CHECK;
    var msg;
    var complete = '';

    if (total < TIER_SHIP) {
      icon = TRUCK;
      msg = 'Add <b>' + money(TIER_SHIP - total) + '</b> more and shipping is on us';
    } else if (total < TIER_DISC) {
      msg = '<b>Free shipping unlocked.</b> Add ' + money(TIER_DISC - total) + ' more for 10% off your order';
    } else {
      msg = '<b>Free shipping and 10% off unlocked.</b> Both are applied at checkout.';
      complete = ' se-rw--complete';
    }

    return (
      '<div class="se-rw se-rw--drawer' + complete + '" data-se-rw>' +
      '<p class="se-rw-msg">' + icon + '<span>' + msg + '</span></p>' +
      '<div class="se-rw-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '" aria-label="Progress towards free shipping and order discount">' +
      '<div class="se-rw-fill" style="width:' + pct + '%"></div>' +
      '<span class="se-rw-dot' + (total >= TIER_SHIP ? ' is-on' : '') + '" style="left:' + SHIP_MARK + '%"></span>' +
      '<span class="se-rw-dot se-rw-dot--end' + (total >= TIER_DISC ? ' is-on' : '') + '"></span>' +
      '</div>' +
      '<div class="se-rw-legend">' +
      '<span class="' + (total >= TIER_SHIP ? 'is-on' : '') + '" style="left:' + SHIP_MARK + '%">Free shipping<i>$100</i></span>' +
      '<span class="se-rw-legend--end ' + (total >= TIER_DISC ? 'is-on' : '') + '">10% off<i>$250</i></span>' +
      '</div></div>'
    );
  }

  function paint(total) {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;

    var existing = drawer.querySelector('[data-se-rw]');

    if (!total || total <= 0) {
      if (existing) existing.remove();
      return;
    }

    var header = drawer.querySelector('.cart-drawer__header');
    if (!header) return;

    injectStyles();

    if (existing) {
      existing.outerHTML = markup(total);
    } else {
      header.insertAdjacentHTML('afterend', markup(total));
    }
  }

  // Open the discount accordion and make it look like a field, everywhere it
  // appears (cart page and drawer both render .cart-discount).
  function openDiscount() {
    injectStyles();
    var nodes = document.querySelectorAll('.cart-discount');
    for (var i = 0; i < nodes.length; i++) {
      var acc = nodes[i];
      if (acc.dataset.seDisc) continue;
      var details = acc.querySelector('details');
      if (!details) continue;

      acc.dataset.seDisc = '1';
      details.setAttribute('open', '');

      var label = acc.querySelector('.cart-discount__label');
      if (label) label.textContent = 'Have a discount code?';

      var input = acc.querySelector('.cart-discount__input');
      if (input) input.setAttribute('placeholder', 'Enter your code');
    }
  }

  var pending = false;

  function refresh() {
    openDiscount();
    if (pending) return;
    pending = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        pending = false;
        var total = cart.original_total_price != null ? cart.original_total_price : cart.total_price;
        paint(total);
        openDiscount();
      })
      .catch(function () { pending = false; });
  }

  document.addEventListener('cart:update', refresh);
  document.addEventListener('click', function (e) {
    if (e.target.closest('[href="/cart"], .header-actions__cart-icon, cart-drawer-component')) {
      setTimeout(refresh, 60);
    }
  });

  function watch() {
    openDiscount();

    var drawer = document.querySelector('cart-drawer-component');
    if (drawer) {
      // Horizon re-renders the drawer's HTML when quantities change, which wipes
      // the injected node. Put it back whenever it goes missing.
      new MutationObserver(function () {
        if (!drawer.querySelector('[data-se-rw]') && drawer.querySelector('.cart-drawer__header')) refresh();
        openDiscount();
      }).observe(drawer, { childList: true, subtree: true });
    }

    var main = document.querySelector('main');
    if (main) {
      new MutationObserver(openDiscount).observe(main, { childList: true, subtree: true });
    }

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
